var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.stage == _vm.CHECKOUT.TICKET
        ? _c("ticket-intro", {
            attrs: { order: _vm.ticket, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.PAYMENT
        ? _c("checkout-payment", {
            attrs: { order: _vm.ticket, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.DSP2
        ? _c("dsp2", {
            attrs: { order: _vm.order, param: _vm.param, modal: _vm.modal },
            on: { go: _vm.go },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.TICKET_SUCCESS
        ? _c("ticket-success", {
            attrs: { order: _vm.ticket, modal: _vm.modal },
            on: {
              go: function ($event) {
                return _vm.go()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stage == _vm.CHECKOUT.SIGNUP_AFTER_CONFIRM
        ? _c("signup-after-confirm", {
            attrs: { order: _vm.ticket, modal: _vm.modal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }